import moment from "moment";
import { theme } from "nectar-ui";
import { DASHBOARD_CHART_TYPES } from "@utils/constants/dashboard/dashboardModuleConstants";
import { ChartGroups } from "@customTypes/chart";
import { ApexOptions } from "apexcharts";

const responsiveOptions = [
  {
    breakpoint: 768,
    options: {
      plotOptions: {
        bar: {
          columnWidth: "60%",
          dataLabels: {
            orientation: "vertical",
            style: {
              fontSize: "12px",
            },
          },
        },
      },
      xaxis: {
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
    },
  },
  {
    breakpoint: 1024,
    options: {
      plotOptions: {
        bar: {
          columnWidth: "70%",
          style: {
            fontSize: "14px",
          },
        },
      },
      xaxis: {
        labels: {
          style: {
            fontSize: "14px",
          },
        },
      },
    },
  },
];

export const getColumnChartOptions = (months: string[], groups: ChartGroups): ApexOptions => {
  return {
    chart: {
      id: DASHBOARD_CHART_TYPES.LAWSUIT_BY_CUSTOMER_OVER_TIME.chart,
      height: "50%",
      type: "bar",
      stacked: true,
      fontFamily: theme.nectar.fontStack.default,
      toolbar: {
        show: false,
      },
    },
    states: {
      active: {
        filter: {
          type: "none",
        },
      },
    },
    colors: [theme.nectar.colors.blue500],
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusWhenStacked: "last",
        borderRadiusApplication: "end",
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "14px",
              color: theme.nectar.colors.gray900,
              fontWeight: 700,
            },
          },
        },
      },
    },
    responsive: responsiveOptions,
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: months,
      position: "bottom",
      axisBorder: {
        show: false,
      },
      labels: {
        formatter(value: string | number) {
          const monthString = moment(value, "YYYY-MM-DD").format("MMM");
          return `${monthString.charAt(0).toUpperCase()}${monthString.slice(1)}`;
        },
        style: {
          fontSize: "14px",
          fontWeight: 300,
          colors: theme.nectar.colors.gray500,
        },
      },
      axisTicks: {
        show: true,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
      group: {
        style: {
          fontSize: "14px",
          fontWeight: 300,
          colors: theme.nectar.colors.gray500,
        },
        groups,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        formatter: (val: number, _opts) => {
          return Math.round(val).toString();
        },
        style: {
          fontSize: "14px",
          fontWeight: 300,
          colors: theme.nectar.colors.gray500,
        },
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      x: {
        formatter(value: string | number) {
          const monthString = moment(value, "YYYY-MM-DD").format("MMMM YY");
          return `${monthString.charAt(0).toUpperCase()}${monthString.slice(1)}`;
        },
      },
      y: {
        title: {
          formatter() {
            return "Cadastrados:";
          },
        },
      },
    },
    title: {
      text: "",
    },
  };
};
